import { Link } from 'react-router-dom';
import { ArrowLeft, Download, Headphones, MessageCircle } from 'lucide-react';

export function KelilingoDownloadPage() {
  const configured = String(import.meta.env.VITE_KELILINGO_DOWNLOAD_URL || '').trim();
  const downloadUrl = /^https:\/\//i.test(configured) ? configured : '';
  return <main className="flex min-h-dvh flex-col bg-canvas px-5 py-8 text-ink">
    <div className="mx-auto w-full max-w-lg"><Link to="/" className="inline-flex items-center gap-2 text-sm text-muted"><ArrowLeft size={16} />返回口播卡</Link>
      <section className="mt-12 rounded-3xl border border-border bg-surface p-8 text-center shadow-sm">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-primary/10 text-primary"><MessageCircle size={32} /></div>
        <p className="mt-5 text-sm font-semibold text-primary">kelilingo</p>
        <h1 className="mt-2 text-2xl font-semibold">离屏对话，在 App 中继续</h1>
        <p className="mt-4 text-sm leading-7 text-muted">戴上耳机，开口回答，与 kelilingo 一起追问和思考。请下载 kelilingo App 使用离屏对话。</p>
        {downloadUrl ? <a href={downloadUrl} className="mt-7 inline-flex items-center justify-center gap-2 rounded-full bg-primary px-6 py-3 font-semibold text-white"><Download size={18} />下载 kelilingo</a> : <p role="status" className="mt-7 rounded-xl bg-canvas p-4 text-sm text-muted">下载入口即将开放</p>}
        <Link to="/" className="mt-5 flex items-center justify-center gap-2 text-sm text-primary"><Headphones size={16} />继续听口播卡</Link>
      </section>
    </div>
  </main>;
}
